














import { Component, Vue, Watch } from "vue-property-decorator";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import EntityModal from "@/layouts/DashboardLayoutComponents/EntityModal.vue";

import inhouseProfessionalModel from "@/models/inhouseProfessional.model";

@Component({
	components: { PaginatedSearch, CreationCard, EntityModal },
})
export default class InhouseProfessionals extends Vue {
	id: any = "";

	inhouseProfessionalModel: any;
	inhouseProfessionalCreationFields = [
		{ key: "name", class: "md-size-40" },
		{ key: "cpf", class: "md-size-20" },
		{ key: "cnpj", class: "md-size-20" },
		{ key: "pisNumber", class: "md-size-20" },
		{ key: "bankNumber", class: "md-size-25" },
		{ key: "agencyNumber", class: "md-size-25" },
		{ key: "accountNumber", class: "md-size-25" },
		{ key: "bankAccountKind", class: "md-size-25" },
		{ key: "employmentRelationship", class: "md-size-33" },
		{ key: "position", class: "md-size-33" },
		{ key: "salary", class: "md-size-33" },
	];
	inhouseProfessionalModalFields = [
		{ icon: "edit", name: "Dados", fields: this.inhouseProfessionalCreationFields },
		{ icon: "delete", name: "Excluir", fields: [
			{ key: "name", class: "md-size-100", props: { disabled: true } },
			{ key: "deletionReason", class: "md-size-50", style: { "margin-bottom": "100px" } },
		]},
	];

	constructor() {
		super();
		this.inhouseProfessionalModel = inhouseProfessionalModel;
	}

	async mounted() {
		this.id = this.$route.params.id;
	}

	@Watch("$route")
	updateRoute(route: any) {
		this.id = route.params.id || "";
	}

	openInhouseProfessional(inhouseProfessional: any) {
		this.$router.push(`/administrativo/profissionais-internos/${inhouseProfessional.id}`);
	}

	closeInhouseProfessional() {
		this.$router.push('.');
		(this.$refs.inhouseProfessionalSearch as any).refresh();
	}
}
